var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPSearchLocationArrowSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9369 3.16571C13.0665 2.85105 12.9924 2.4888 12.7518 2.24818C12.5112 2.00756 12.1489 1.93352 11.8342 2.06309L2.52597 5.87071C2.15047 6.02408 1.93892 6.42071 2.01561 6.81733C2.0923 7.21396 2.44135 7.49953 2.84594 7.49953H7.50006V12.1533C7.50006 12.5579 7.78565 12.9043 8.18231 12.9836C8.57897 13.0629 8.97562 12.8487 9.129 12.4733L12.9369 3.16571Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPSearchLocationArrowSecondary);
export default __webpack_public_path__ + "static/media/p_search_location_arrow_secondary.dae7dcc2cd6b3a57209aae598c96d1b7.svg";
export { ForwardRef as ReactComponent };